export default __webpack_public_path__ + "static/media/poster.8898f91c.jpg";